import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialCementPackagingPageState,
  CementPackagingItemData,
} from "../core/_model.cementPackaging";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedCementPackaging = {
  data: CementPackagingItemData | null;
  action: ActionsKey;
};

type CementPackagingDataType = {
  cementPackagingList: any;
  detail: CementPackagingItemData | null;
  actioned: ActionedCementPackaging | null;
  totalItems?: number;
  setDetail: (detail: CementPackagingItemData | null) => void;
  setCementPackagingList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedCementPackaging | null) => void;
};

export const useCementPackagingStore = create<CementPackagingDataType>(
  (set) => ({
    cementPackagingList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setCementPackagingList: (saleData) =>
      set((state) => ({
        cementPackagingList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useCementPackagingListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialCementPackagingPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
